<template>
    <router-view v-if="hasChildView" />
    <div v-else class="container">
        <div class="row">
            <div class="col-xs-12">
                <h1 class="vrm-page-title">
                    {{
                        $t('mfa.landing_title', {
                            i18nFallback: 'Change your VRM two-step verification settings',
                        })
                    }}
                </h1>
                <p>
                    {{
                        $t('mfa.landing_explanation', {
                            i18nFallback:
                                'Protect your account against unauthorized access with two-step verification. Two-step verification adds an extra layer of protection to your account by requiring you to enter both your password and a security code recieved on your mobile phone when logging in to VRM. For your convenience you can upon login specify to never ask for a security code on the current device again. From that point on you only need to enter your password when accessing the VRM website from that device.',
                        })
                    }}
                    <br />
                    <br />
                    <a
                        href="https://www.victronenergy.com/live/vrm_portal:two-step-verification"
                        target="_blank"
                    >
                        {{ $t('mfa.landing_learn_more', { i18nFallback: 'Learn more' }) }}
                    </a>
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <vrm-mfa-options-form :readonly="!autorized" @change-method="changeMethod" />
                <div v-if="!autorized" class="sg-btn__container sg-btn__container--align-left">
                    <router-link
                        to="base.profile.twofactor.authorize"
                        tag="button"
                        class="sg-btn sg-blue"
                    >
                        {{ $t('mfa.landing_make_changes', { i18nFallback: 'Make changes' }) }}
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularRoute } from '@/vue/decorators/angular-interop';
import VrmMfaOptionsForm from '@/vue/components/shared/VrmMfaOptionsForm';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component({
    components: { VrmMfaOptionsForm },
})
@AngularRoute('base.profile.twofactor', '/twofactor', { slot: 'body' })
@AngularLocaleBundle('twofactor')
@AngularLocaleBundle('mfa')
export default class Index extends Vue {
    get hasChildView() {
        return this.$route.name !== 'base.profile.twofactor';
    }

    get autorized() {
        return this.$store.getters['MfaService/hasProtectedAccess'];
    }

    changeMethod(newMethod) {
        switch (newMethod) {
            default:
                return;
            case 'password':
                return this.$router.push('base.profile.twofactor.password');
            case 'sms':
                return this.$router.push('base.profile.twofactor.sms');
            case 'mobile':
                return this.$router.push('base.profile.twofactor.mobile');
        }
    }
}
</script>
